//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
		props: {
			data: {
				type: Array
			},
			error: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				swiperOption: {
					direction: 'vertical',
					slidesPerView: 'auto',
					freeMode: true,
					scrollbar: {
						el: '.swiper-scrollbar',
						hide: true,
						draggable: true
					},
					mousewheel: true,
					observer: true,
					observeParents: true
				}
			}
		},
		computed: {}
	}




// WEBPACK FOOTER //
// ./src/components/ullist.vue